// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"CustomDropdown__dropdown___gks0b","text":"CustomDropdown__text___HYhf1","select":"CustomDropdown__select___3wQ7x"};